<template>
  <router-link class="comp-ui-brand" tag="div" data-analytics-linkName="mercedes_benz" data-analytics-linkCategory="header" :to="`/${$i18n.locale}/`">
    <img src="../../assets/img/brand-star.png" alt="Mercedes Benz Star"/>
    <SVGBrandName :class="[$i18n.locale]" />
  </router-link>
</template>

<script>
  import SVGBrandName from '@/assets/svg/brand-logo.svg?inline';

  export default {
    name: 'Logo',
    components: {
      SVGBrandName,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {},
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {};
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    filters: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {},
  };
</script>

<style lang="scss">
  @import '~scss/variables';
  @import '~scss/mixins';

  .comp-ui-brand {
    width: 234px;
    height: 63px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    user-select: none;
    cursor: pointer;

    @include low-height-desktop {
      height: 43px;
      width: 177px;
    }

    @include screen-mobile {
      height: 43px;
      width: 177px;
    }

    img {
      width: 63px;
      height: auto;

      @include low-height-desktop {
        width: 43px;
        height: auto;
      }

      @include screen-mobile {
        width: 43px;
        height: auto;
      }
    }

    svg {
      user-select: none;
      margin-bottom: 5px;
      width: 112px;
      height: auto;

      & > path, & > g:first-of-type {
        display: none;
      }

      &.de {
        & > g:first-of-type {
          display: block;
        }
      }

      &.fr, &.it, &.en {
        & > path {
          display: block;
        }
      }

      @include low-height-desktop {
        width: 99px;
      }
    }
  }
</style>
